import { useEffect, useState } from "react";
import api from "../../lib/api";
import { ServicesSection, HowItWorksSection, WhySection, FinalCta } from "../../components/sections";
import { Reveal } from "../../components/Reveal";

export default function Services() {
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/content/services").then(({ data }) => setServices(data)); }, []);
  return (
    <>
      <section className="pt-36 pb-8 px-5 sm:px-8" data-testid="services-page">
        <div className="max-w-7xl mx-auto text-center">
          <Reveal>
            <span className="text-xs font-bold uppercase tracking-[0.18em] text-brand-orange">Video Services</span>
            <h1 className="mt-3 font-heading font-extrabold text-4xl sm:text-6xl text-brand-purpleDeep leading-tight">
              Whatever you need to say,<br className="hidden sm:block" /> we'll help you show it.
            </h1>
            <p className="mt-5 text-lg text-brand-purpleDeep/60 max-w-2xl mx-auto">
              One team for every kind of video your business needs — from a single brand film to an ongoing content engine.
            </p>
          </Reveal>
        </div>
      </section>
      <ServicesSection services={services} />
      <HowItWorksSection />
      <WhySection />
      <FinalCta />
    </>
  );
}
